import styled from 'styled-components';
import { color } from 'asserts/styles/colors';

import { ReactComponent as IconDownLoad } from 'asserts/icons/ic_download_lined.svg';
import { ReactComponent as IconCheck } from 'asserts/icons/ic_nav_arrow_down.svg';

interface LayoutProps {
  title: string;
  children?: React.ReactNode;
  onExcelDownload: () => void;
  result: string;
}

const Layout = ({ children, title, result, onExcelDownload }: LayoutProps) => {
  const isButtonDisabled = result !== 'success';

  return (
    <LayoutWrapper>
      <Wrapper>
        <h3>{title}</h3>
        <ButtonWrapper>
          <DownLoadButton
            onClick={onExcelDownload}
            disabled={isButtonDisabled}
            $isButtonDisabled={isButtonDisabled}
          >
            <p>다운로드</p>
            <IconDownLoad />
          </DownLoadButton>
        </ButtonWrapper>
      </Wrapper>
      {children}
    </LayoutWrapper>
  );
};

export default Layout;

const LayoutWrapper = styled.div`
  padding-bottom: 48px;
  border-bottom: 6px solid ${color.white01};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 52px auto 28px;

  & h3 {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.3px;
    line-height: 30px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
  z-index: 10;

  .ant-select-selection-item {
    text-align: left;
  }

  & a {
    text-decoration: none;
  }

  & .ant-select {
    width: 120px;
    position: relative;
    border: 1px solid ${color.white01};
    border-radius: 4px;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  img {
    width: 16px;
  }
`;

const DownLoadButton = styled.button<{ $isButtonDisabled: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 120px;
  padding: 6px 12px;
  color: ${(props) =>
    props.$isButtonDisabled ? `${color.white01}` : `${color.white}`};
  border: 1px solid ${color.white01};
  font-size: 14px;
  border-radius: 4px;
  cursor: ${(props) => (props.$isButtonDisabled ? 'default' : 'pointer')};

  & p {
    line-height: 18px;
  }
`;

const RotatingIcon = styled(IconCheck).withConfig({
  shouldForwardProp: (prop) => prop !== 'rotated'
})<{ rotated: boolean }>`
  transition: transform 0.3s;
  transform: rotate(${(props) => (props.rotated ? '180deg' : '0deg')});
`;
